import { useState, useEffect } from "react";
import { loadBeneficiary } from "../actions";

const useUserBeneficiary = ({ userId }) => {
  const [beneficiary, setBeneficiary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!userId) return;

    const fetchBeneficiary = async () => {
      try {
        setError(null);
        setLoading(true);
        const beneficiaryData = await loadBeneficiary(userId);
        setBeneficiary(beneficiaryData);
      } catch (e) {
        setError(e.response.data.message ?? e.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBeneficiary();
  }, [userId]);

  return { beneficiary, loading, error };
};

export default useUserBeneficiary;
